export default __webpack_public_path__ + "static/media/time-tracker-electron-sm.7a094fd1.jpg";